import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { SearchSubmitButton } from '../../../Components/Custom/SearchSubmitButton';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { columns } from './columns';
import {
  exportHeaders,
  exportMatchingBonus,
  getMatchingBonus,
  paramsForExport,
  removeMatchingBonusForExport
} from './slice';
import { Filters } from './filters';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import { dateForExport } from '../../../helpers/helpers';
import { Pagination } from '../../../Components/Custom/pagination';

const PAGE_TITLE = 'Matching Bonus';

const INITIAL_PARAMS: {
  sortBy: string;
  sortOrder: string;
  countPerPage: string;
  numberOfPage: string;
} = {
  sortBy: 'dateCreated',
  sortOrder: 'DESC',
  countPerPage: '10',
  numberOfPage: '1'
};

const MatchingBonusPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);
  const { loading, loadingExport, data, dataForExport, totalCount } =
    useAppSelector((state) => state.matchingBonus);

  useEffect(() => {
    dispatch(getMatchingBonus(searchParams));
  }, [searchParams]);

  document.title = 'Package Orders | United One Admin';
  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Bonuses' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading || loadingExport}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                title={PAGE_TITLE}
                actions={
                  <>
                    <CsvExport
                      action={() =>
                        dispatch(
                          exportMatchingBonus(paramsForExport(searchParams))
                        )
                      }
                      data={dataForExport}
                      headers={exportHeaders}
                      disabled={loading || loadingExport}
                      fileName={`matchingBonus-${dateForExport}`}
                      removeDataAction={removeMatchingBonusForExport}
                      buttonName='Export filtered data'
                    />
                    {/* <Button
                      color='primary'
                      disabled={loading || loadingExport}
                      onClick={() => setIsOpen(!isOpen)}>
                      Export all users to email
                    </Button> */}
                  </>
                }
              />
              <CardBody className='pt-0'>
                <Filters
                  params={searchParams}
                  setParams={setSearchParams}
                  initialParams={INITIAL_PARAMS}
                />

                <TableContainer
                  columns={columns}
                  data={data.userMatchingBonuses || []}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />
                <Pagination
                  totalCount={totalCount}
                  data={data?.userMatchingBonuses}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MatchingBonusPage;
